import React from 'react';
import { StaticContext } from 'react-router';
import { Link } from 'react-router-dom';
import Error from 'components/Error';

interface Props {
  staticContext?: StaticContext & { requestId: string };
}

export default function Error404({ staticContext }: Props) {
  if (staticContext) staticContext.statusCode = 404;
  return (
    <Error title="Where's Fido?!" staticContext={staticContext}>
      <div>We can&lsquo;t find what you&lsquo;re looking for!</div>
      <a href="/">Go Home</a>
    </Error>
  );
}
